const NotificationCard = () => {
	const orderValue = [19.99, 34.99, 49.99, 39.89, 59.97, 24.99];

	const getRandomOrderValue = () => {
		const randomIndex = Math.floor(Math.random() * orderValue.length);
		return orderValue[randomIndex].toFixed(2);
	};

	return (
		<div className="notifications-list flex max-h-[600px] flex-col gap-4 overflow-auto">
			<div className="rounded-2xl border border-[#3f4156]/70 bg-white bg-opacity-[.02] px-6 py-2.5 text-white backdrop-blur-md">
				<div className="flex flex-wrap items-center gap-6">
					<div className="flex w-full items-center gap-4">
						<div>
							<div className="flex h-[55px] w-[55px] items-center justify-center rounded-xl bg-white p-2">
								<img
									className="w-full max-w-[45px]"
									src="/images/landingpage/shopifyLogo.svg"
									alt="PagePilot.ai Shopify Logo"
									width="45"
									height="45"
								/>
							</div>
						</div>

						<div className="w-full flex-col gap-1">
							<div className="flex w-full justify-between font-inter">
								<div className="font-medium">Shopify</div>
								<div className="text-sm text-[#8a8a8a]">1m ago</div>
							</div>
							<div className="inline-flex font-inter text-sm">
								<div>Your Store has a new order for 1 item totaling ${getRandomOrderValue()}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NotificationCard;
